import { render, staticRenderFns } from "./CouponPop.vue?vue&type=template&id=036b9458&scoped=true&"
import script from "./CouponPop.vue?vue&type=script&lang=js&"
export * from "./CouponPop.vue?vue&type=script&lang=js&"
import style0 from "./CouponPop.vue?vue&type=style&index=0&id=036b9458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b9458",
  null
  
)

export default component.exports